import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import DashboardLayout from './layouts/DashboardLayout';
import styles from './DashboardLoader.module.scss';
import { Spinner } from '@chakra-ui/react';
export default function DashboardLoader() {
    return /*#__PURE__*/ _jsx(DashboardLayout, {
        containerProps: {
            className: styles.loader
        },
        children: /*#__PURE__*/ _jsx(Spinner, {})
    });
}
